module.exports = __webpack_public_path__ + "static/media/wax.d94862b9.webp";